package features.watch

import features.watch.model.WatchEntry
import kotlin.math.roundToInt

object WatchRules {
    const val ENGAGE_FLOOR_SEC = 5 * 60
    const val SHORT_RUNTIME_SEC = 15 * 60
    private const val SHORT_FRACTION = 0.25
    const val COMPLETE_FRACTION = 0.90

    fun qualified(engagedSec: Int, durationSec: Int): Boolean {
        if (durationSec in 1 until SHORT_RUNTIME_SEC) {
            return engagedSec >= (durationSec * SHORT_FRACTION).roundToInt()
        }
        return engagedSec >= ENGAGE_FLOOR_SEC
    }

    fun visibleInContinue(entry: WatchEntry): Boolean {
        if (entry.isDeleted || entry.hiddenFromContinue) return false
        if (entry.status != WatchEntry.STATUS_IN_PROGRESS) return false
        if (entry.progress >= COMPLETE_FRACTION) return false
        val queuedNext = entry.isTvShow && entry.positionSec <= 0 && entry.engagedSec <= 0
        if (queuedNext) return true
        return qualified(entry.engagedSec, entry.durationSec)
    }

    fun continueList(entries: List<WatchEntry>): List<WatchEntry> {
        return entries
            .filter(::visibleInContinue)
            .groupBy { it.videoId }
            .mapNotNull { (_, rows) -> rows.maxByOrNull { it.changedAt } }
            .sortedByDescending { it.changedAt }
            .take(20)
    }

    fun inHistory(entry: WatchEntry): Boolean {
        if (entry.isDeleted) return false
        if (entry.status == WatchEntry.STATUS_COMPLETED) return true
        return qualified(entry.engagedSec, entry.durationSec)
    }

    fun shouldSync(entry: WatchEntry): Boolean {
        if (entry.isDeleted || entry.hiddenFromContinue) return true
        if (entry.status == WatchEntry.STATUS_COMPLETED) return true
        if (visibleInContinue(entry)) return true
        return qualified(entry.engagedSec, entry.durationSec)
    }
}
